import { InvoiceFinanceProvider } from 'api';
import { SelectField, SelectFieldProps } from 'form';

export type InvoiceFinanceProviderSelectFieldProps = Omit<SelectFieldProps, 'options'>;

const options: SelectFieldProps['options'] = Object.entries(InvoiceFinanceProvider).map(([key, value]) => ({
  label: key,
  value,
}));

export const InvoiceFinanceProviderSelectField = ({ ...props }: InvoiceFinanceProviderSelectFieldProps) => {
  return <SelectField {...props} options={options} />;
};
